import React, { JSX } from 'react'

/**
 * Props for link components
 */
export interface LinkComponentProps {
  href?: string
  target?: '_blank' | '_self' | '_parent' | '_top'
  rel?: string
}

/**
 * Custom hook that returns the appropriate component based on the provided element type.
 * If a component is provided, it returns that component.
 * Otherwise, it returns the HTML element type as a string.
 *
 * @param elementType - The element type to render
 * @returns The resolved component to render
 */
export const useLink = (
  elementType: React.ElementType | keyof JSX.IntrinsicElements
): React.ElementType => {
  // If elementType is a component (function or class), return it directly
  if (typeof elementType !== 'string') {
    return elementType
  }

  // Otherwise, return the string element type
  return elementType
}
